module.exports = function() {
  return new Worker(__webpack_public_path__ + "2ba8a0d57446bceb45eb.worker.js");
};